/**
 * ListViewSchema for Item DocType
 * 
 * Schema-driven configuration for Item list page.
 * 
 * This schema replaces hardcoded column definitions and default filters.
 * All list layout changes should be made in this file.
 */

import type { ListViewSchema } from "./types";

export const itemListViewSchema: ListViewSchema = {
  doctype: "Item",
  views: {
    experience: {
      columns: [
        {
          fieldname: "item_code",
          label: "Item Code",
          width: 180,
          align: "left",
          type: "Data",
          sortable: true,
        },
        {
          fieldname: "item_name",
          label: "Item Name",
          width: "grow",
          align: "left",
          type: "Data",
          sortable: true,
        },
        {
          fieldname: "storefront_enabled",
          label: "Storefront",
          width: 100,
          align: "center",
          type: "Check",
          sortable: false,
          hideOnMobile: true,
        },
        {
          fieldname: "item_group",
          label: "Item Group",
          width: 160,
          align: "left",
          type: "Link",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "standard_rate",
          label: "Standard Rate",
          width: 140,
          align: "right",
          type: "Currency",
          sortable: true,
        },
        {
          fieldname: "is_stock_item",
          label: "Stock Item",
          width: 120,
          align: "center",
          type: "Check",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "marketplace_source",
          label: "Source",
          width: 100,
          align: "center",
          type: "Tag",
          sortable: true,
          hideOnMobile: true,
        },
        {
          fieldname: "disabled",
          label: "Status",
          width: 120,
          align: "center",
          type: "Status",
          sortable: false,
        },
      ],
      defaultSort: {
        fieldname: "modified",
        direction: "desc",
      },
      defaultFilters: [
        ["disabled", "=", 0], // Show only enabled items by default
      ],
      quickFilters: [
        {
          id: "all",
          label: "All",
          filters: [],
          default: true,
        },
        {
          id: "template_items",
          label: "Template Items",
          filters: [["has_variants", "=", 1]],
        },
        {
          id: "single_items",
          label: "Single Items",
          filters: [["has_variants", "=", 0]],
        },
        {
          id: "active_items",
          label: "Active Only",
          filters: [["disabled", "=", 0]],
        },
        {
          id: "lazada",
          label: "Lazada",
          filters: [["marketplace_source", "=", "Lazada"]],
        },
      ],
      pageSizeOptions: [20, 50, 100, 200, 400, 500],
    },
  },
};

